const { createSlice } = require("@reduxjs/toolkit");

const initialState = {
  orderDetailsItem: {},
};

const orderDetailsSlice = createSlice({
  name: "orderdetail",
  initialState: initialState,
  reducers: {
    setOrderDetailsItem(state, action) {
      state.orderDetailsItem = action.payload;
    },
  },
});

export const { setOrderDetailsItem } = orderDetailsSlice.actions;

export default orderDetailsSlice.reducer;
